import React from 'react';
import { motion } from 'framer-motion';
import { zonas } from '../data/zonas.ts';

const ZonasTuristicas: React.FC = () => {
  return (
    <motion.div
      className="max-w-7xl mx-auto px-4 py-10 mt-16"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1 className="text-3xl font-bold text-center text-blue-800 mb-8">
        Zonas Turísticas de Pucallpa y Ucayali
      </h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {zonas.map((zona, idx) => (
          <motion.div
            key={idx}
            className="rounded-2xl shadow-md overflow-hidden bg-white cursor-pointer"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            whileHover={{ scale: 1.03, boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.15)' }}
            transition={{ duration: 0.3, delay: idx * 0.1 }}
            viewport={{ once: true }}
          >
            <img
              src={zona.imagen}
              alt={zona.titulo}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h2 className="text-xl font-semibold text-blue-700 mb-2">{zona.titulo}</h2>
              <p className="text-gray-700 text-base">{zona.descripcion}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ZonasTuristicas;
